import { OnboardingVideoBannerController } from './onboarding-video-banner.controller'

function onboardingVideoBanner () {
  return {
    restrict: 'E',
    templateUrl: '/arts/directives/onboarding-video-banner/onboarding-video-banner-directive.html?$$REVISION$$',
    controller: OnboardingVideoBannerController
  }
}

export { onboardingVideoBanner }
